'use strict';

/**
 * Global project configuration
 **/
export const GlobalConfig = Object.freeze({
    // DebugMode project
    _debugMode: true,
    // If the project is oneClient or multiClient. Use [url_client. ej. rebus] o false
    _isOneClient: 'expocotelco2017',
    // Default Language
    _defaultLang: 'es',
    // Domain
    _domain: 'http://localhost:9422',
    // Time Zone
    _timezone: 'America/Bogota',
    _timezoneHour: '-05:00',
    // Delay time execution of connect data. Use [Integer]
    _timeoutConnect: 20000,
    _eventDefaultBlocked: {
      "configMenu": {
        "isMenu": true,
        "menuCinco": "networking",
        "menuCuatro": "map",
        "menuDos": "social",
        "menuSeis": "profile",
        "menuTres": "speaker",
        "menuUno": "diary"
      },
      "configSponsor": {
        "autoplay": "3000",
        "direction": "horizontal",
        "loop": true,
        "pager": false,
        "speed": "2000"
      },
      "defaultLanguage": "es",
      "id": "expocotelco2017",
      "languages": ["es"],
      "modules": {
        "activity": true,
        "catalog": true,
        "diary": true,
        "embed": true,
        "embedSecond": true,
        "map": true,
        "message": true,
        "networking": true,
        "news": true,
        "now": true,
        "opinometer": true,
        "question": true,
        "social": true,
        "speaker": true,
        "sponsor": true,
        "stands": true,
        "streaming": true
      },
      "name": "Congreso y Expocotelco ",
      "nit": "N/A",
      "permissions": {
        "defaultPage": "RoomPage",
        "forgot": true,
        "loginAlternative": "Email",
        "loginBlocked": true,
        "loginRequired": false,
        "loginSocial": {
          "facebook": true,
          "google": true,
          "twitter": true
        },
        "register": true
      },
      "secretCode": "expocotelco2017",
      "state": true,
      "styles": {
        "buttonDos": "expocotelco2017_button_dos",
        "buttonUno": "expocotelco2017_button_uno",
        "colorCuatro": "#ffffff",
        "colorDos": "#1086AF",
        "colorTres": "#002C52",
        "colorUno": "#002C52",
        "folder": "expocotelco2017",
        "footer": "expocotelco2017_footer",
        "header": "expocotelco2017_header"
      },
      "url": "expocotelco2017"
    }
});
// end file



// WEBPACK FOOTER //
// ./src/app/app.config.ts